import {ActionReducerMap, MetaReducer} from '@ngrx/store';
import {cloneDeep} from 'lodash';
import {AbydosState, coreInitialState, coreReducer, defaultReducer} from '@abydos-angular/store';
import {AuthActionTypes, AuthInfoState, authInitialState} from '@abydos-angular/rest-api';

export interface AppState extends AbydosState {
    auth: AuthInfoState;
}

export const appMetaReducers: MetaReducer<AppState>[] = [clearState];

export function clearState(reducer: any) {
    return (state: any, action: any) => {
        switch (action.type) {
            case AuthActionTypes.RESET_STATE: {
                if (action.keepAuthState) {
                    const _auth = state.auth;
                    state = cloneDeep(appInitialState);
                    state.auth = _auth;
                } else {
                    state = cloneDeep(appInitialState);
                }
                break;
            }
        }
        return reducer(state, action);
    };
}

export const appInitialReducerMap: ActionReducerMap<AppState> = {
    core: coreReducer,
    auth: defaultReducer,
};

export const appInitialState = {
    core: coreInitialState,
    auth: authInitialState,
} as AppState;
